import React from 'react'

export default function pdfToImage(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <g clip-path="url(#a)">
          <path
            fill="currentColor"
            d="m25.91 5.89-.3-.3L21.02 1l-.2-.2c-.5-.5-1.2-.8-1.9-.8H3.05C1.55 0 .25 1.3.25 2.8v26.85c0 1.6 1.3 2.8 2.8 2.8h13.18c-.2-.3-.3-.7-.4-1H3.25c-1.1 0-2-.9-2-2V2.9c0-1 .8-1.8 1.8-1.8h15.97c.3 0 .7.1.9.4l.5.5 4.19 4.19.7.7c.2.2.3.4.3.7v12.28c.3 0 .6.1.9.1V7.49c0-.6-.2-1.2-.6-1.6Z"
          />
          <path
            fill="currentColor"
            fill-opacity=".1"
            d="M26.57 7.81v12.11c-.61-.1-1.21-.2-1.82-.2-4.85-.3-8.99 3.33-9.4 8.07v1.01c0 1.11.2 2.32.71 3.33H2.52c-1.11 0-2.02-.91-2.02-2.02V2.26C.5 1.15 1.41.24 2.52.24H19.5c.51 0 1.01.2 1.41.61l5.05 5.25c.4.4.61 1.11.61 1.72v-.01Z"
            opacity=".1"
          />
          <path
            fill="currentColor"
            d="M15 10.417a2.34 2.34 0 0 0 1.111-.274c.329-.178.585-.432.737-.73a1.35 1.35 0 0 0 .114-.938 1.56 1.56 0 0 0-.548-.832 2.176 2.176 0 0 0-1.024-.445 2.432 2.432 0 0 0-1.155.093 1.968 1.968 0 0 0-.898.598c-.22.267-.337.582-.337.903 0 .431.21.844.586 1.149.375.305.884.476 1.414.476Zm0-2.167a.78.78 0 0 1 .37.092c.11.06.196.144.246.243a.45.45 0 0 1 .038.313.52.52 0 0 1-.183.277.725.725 0 0 1-.34.148.81.81 0 0 1-.386-.03.656.656 0 0 1-.3-.2.473.473 0 0 1-.112-.301c0-.144.07-.281.196-.383A.752.752 0 0 1 15 8.25Z"
          />
          <path
            fill="currentColor"
            d="M19.667 5H6.333c-.353 0-.692.114-.942.317S5 5.796 5 6.083v10.834c0 .287.14.563.39.766.25.203.59.317.943.317h13.334c.353 0 .692-.114.942-.317s.391-.479.391-.766V6.083c0-.287-.14-.563-.39-.766A1.504 1.504 0 0 0 19.666 5Zm0 11.917H6.333v-3.25l3.334-2.709 3.726 3.028c.25.202.588.315.94.315.353 0 .69-.113.94-.315l1.06-.861 3.334 2.708v1.084Zm0-2.617-2.394-1.944a1.505 1.505 0 0 0-.94-.315c-.352 0-.69.113-.94.315l-1.06.861-3.726-3.028a1.504 1.504 0 0 0-.94-.315c-.353 0-.69.113-.94.315l-2.394 1.945v-6.05h13.334V14.3ZM24.5 30H21c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm0-9c-4.1 0-7.5 3.3-7.5 7.5s3.3 7.5 7.5 7.5 7.5-3.3 7.5-7.5c-.1-4.1-3.4-7.4-7.5-7.5Z"
          />
          <path
            fill="currentColor"
            fill-opacity=".1"
            d="M24.5 30H21c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Z"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h32v36H0z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
